module.exports = __webpack_public_path__ + "img/i.2402ded1.svg";